module.exports = {"name":"youboralib","type":"lib","tech":"js","author":"Jordi Aguilar","version":"6.1.11","built":"2018-01-30","repo":"https://bitbucket.org/npaw/lib-plugin-js.git"}


//////////////////
// WEBPACK FOOTER
// ./~/youboralib/manifest.json
// module id = 28
// module chunks = 0